/* DIALED chrome: header, mobile menu, shop panel, cart drawer (Cart AJAX API +
   Section Rendering API), gallery tabs, sticky buy bar, form validation. */
(function () {
  'use strict';

  var D = (window.DLD = window.DLD || {});
  var doc = document;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var lockCount = 0;

  D.money = function (cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var locale = doc.documentElement.lang || 'en';
    var amount = (Number(cents) || 0) / 100;
    var whole = Math.abs(amount - Math.round(amount)) < 0.005;
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(amount);
    } catch (e) {
      return (whole ? Math.round(amount) : amount.toFixed(2)) + ' ' + currency;
    }
  };

  D.lock = function () { if (!lockCount++) doc.documentElement.setAttribute('data-dld-lock', ''); };
  D.unlock = function () { if (lockCount > 0 && !--lockCount) doc.documentElement.removeAttribute('data-dld-lock'); };
  D.validEmail = function (v) { return EMAIL_RE.test(String(v || '').trim()); };

  /* ---------------------------------------------------------------- cart */
  var cart = (D.cart = {
    el: null,
    lastFocus: null,
    init: function () {
      this.el = $('[data-dld-cart]');
      if (!this.el) return;
      var self = this;
      this.el.addEventListener('click', function (e) {
        if (e.target.closest('[data-dld-cart-close]')) { self.close(); return; }
        var q = e.target.closest('[data-dld-qty]');
        if (q) self.change(q.getAttribute('data-line'), q.getAttribute('data-qty'));
      });
      doc.addEventListener('click', function (e) {
        var pq = e.target.closest('[data-dld-cart-page] [data-dld-qty]');
        if (pq) {
          pq.disabled = true;
          fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(pq.getAttribute('data-line')), quantity: Number(pq.getAttribute('data-qty')) }) })
            .then(function () { location.reload(); }).catch(function () { pq.disabled = false; });
          return;
        }
        var o = e.target.closest('[data-dld-cart-open]');
        if (o) { e.preventDefault(); self.open(); return; }
        var u = e.target.closest('[data-dld-upsell]');
        if (u) { u.disabled = true; self.add([{ id: Number(u.getAttribute('data-dld-upsell')), quantity: 1 }]); }
      });
    },
    isOpen: function () { return this.el && !this.el.hidden; },
    open: function () {
      if (!this.el || this.isOpen()) return;
      this.lastFocus = doc.activeElement;
      this.el.hidden = false;
      D.lock();
      doc.body.classList.add('dld-cart-open');
      var closeBtn = $('[data-dld-cart-close]:not(.dld-cart__scrim)', this.el);
      if (closeBtn) closeBtn.focus();
      doc.dispatchEvent(new CustomEvent('dialed:cart:open'));
    },
    close: function () {
      if (!this.el || !this.isOpen()) return;
      this.el.hidden = true;
      D.unlock();
      doc.body.classList.remove('dld-cart-open');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      doc.dispatchEvent(new CustomEvent('dialed:cart:close'));
    },
    setBusy: function (on) { if (this.el) this.el.classList.toggle('is-busy', !!on); },
    render: function (html) {
      if (!html || !this.el) return;
      var tpl = doc.createElement('template');
      tpl.innerHTML = html;
      var fresh = tpl.content.querySelector('[data-dld-cart]');
      if (!fresh) return;
      this.el.innerHTML = fresh.innerHTML;
      this.el.setAttribute('data-count', fresh.getAttribute('data-count') || '0');
      this.updateCount(fresh.getAttribute('data-count'));
    },
    updateCount: function (n) {
      if (n == null) return;
      $$('[data-dld-cart-count]').forEach(function (el) {
        if (el.textContent !== String(n)) {
          var btn = el.closest('.dld-cart-btn');
          if (btn) { btn.classList.remove('is-bumped'); void btn.offsetWidth; btn.classList.add('is-bumped'); }
        }
        el.textContent = n;
      });
      $$('[data-dld-cart-open][data-label-template]').forEach(function (el) {
        el.setAttribute('aria-label', el.getAttribute('data-label-template').replace('{count}', n));
      });
    },
    error: function (msg) {
      var box = this.el && $('[data-dld-cart-error]', this.el);
      if (box) { box.textContent = msg; box.hidden = false; }
    },
    request: function (url, body) {
      var self = this;
      var payload = Object.assign({}, body, { sections: 'dialed-cart-drawer' });
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
          if (data.sections && data.sections['dialed-cart-drawer']) self.render(data.sections['dialed-cart-drawer']);
          return data;
        });
      });
    },
    add: function (items) {
      var self = this;
      this.setBusy(true);
      return this.request('/cart/add.js', { items: items })
        .then(function (d) { self.open(); doc.dispatchEvent(new CustomEvent('dialed:cart:added', { detail: d })); return d; })
        .catch(function (e) { self.open(); self.error(e.message); })
        .then(function () { self.setBusy(false); });
    },
    change: function (line, qty) {
      var self = this;
      this.setBusy(true);
      return this.request('/cart/change.js', { line: Number(line), quantity: Number(qty) })
        .catch(function (e) { self.error(e.message); })
        .then(function () { self.setBusy(false); });
    },
    refresh: function () {
      var self = this;
      return fetch('/?sections=dialed-cart-drawer', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { self.render(d['dialed-cart-drawer']); })
        .catch(function () {});
    }
  });

  /* -------------------------------------------------------------- header */
  function initHeader() {
    var header = $('[data-dld-header]');
    if (!header) return;
    var toggle = $('[data-dld-shop-toggle]', header);
    var panel = $('[data-dld-shop-panel]', header);
    var hoverable = window.matchMedia('(hover: hover)').matches;

    function openShop() { if (!panel || !toggle) return; panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); }
    function closeShop() { if (!panel || !toggle) return; panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
    D.closeShop = closeShop;

    if (toggle && panel) {
      if (hoverable) {
        toggle.addEventListener('mouseenter', openShop);
        toggle.addEventListener('focus', openShop);
        $$('.dld-nav__link:not([data-dld-shop-toggle])', header).forEach(function (l) { l.addEventListener('mouseenter', closeShop); });
        header.addEventListener('mouseleave', closeShop);
      } else {
        toggle.addEventListener('click', function (e) {
          if (panel.hidden) { e.preventDefault(); openShop(); }
        });
      }
      header.addEventListener('focusout', function (e) {
        if (!header.contains(e.relatedTarget)) closeShop();
      });
      doc.addEventListener('click', function (e) { if (!header.contains(e.target)) closeShop(); });
      panel.addEventListener('click', function (e) { if (e.target.closest('a')) closeShop(); });
    }

    var menu = $('[data-dld-menu]');
    var burger = $('[data-dld-menu-toggle]', header);
    var lastFocus = null;
    function openMenu() {
      if (!menu) return;
      lastFocus = doc.activeElement;
      menu.hidden = false;
      D.lock();
      if (burger) burger.setAttribute('aria-expanded', 'true');
      var c = $('[data-dld-menu-close]', menu);
      if (c) c.focus();
    }
    function closeMenu() {
      if (!menu || menu.hidden) return;
      menu.hidden = true;
      D.unlock();
      if (burger) { burger.setAttribute('aria-expanded', 'false'); if (lastFocus) lastFocus.focus(); }
    }
    D.closeMenu = closeMenu;
    if (burger && menu) {
      burger.addEventListener('click', function () { menu.hidden ? openMenu() : closeMenu(); });
      menu.addEventListener('click', function (e) {
        if (e.target.closest('[data-dld-menu-close]')) closeMenu();
        else if (e.target.closest('a')) closeMenu();
      });
    }
  }

  /* ---------------------------------------------------------- galleries */
  function initGalleries() {
    $$('[data-dld-gallery]').forEach(function (g) {
      var tabs = $$('[role="tab"]', g);
      var slides = $$('[data-dld-slide]', g);
      var tag = $('[data-dld-gallery-tag]', g);
      var count = $('[data-dld-gallery-count]', g);
      function select(i) {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
        slides.forEach(function (s, j) { s.hidden = j !== i; });
        if (tag) tag.textContent = tabs[i].getAttribute('data-label') || '';
        if (count) count.textContent = tabs[i].getAttribute('data-count') || '';
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
          if (n === null) return;
          n = (n + tabs.length) % tabs.length;
          select(n); tabs[n].focus(); e.preventDefault();
        });
      });
      if (tabs.length) select(0);
    });
  }

  /* -------------------------------------------------------- sticky bar */
  function initSticky() {
    var bar = $('[data-dld-sticky]');
    var box = $('[data-dld-buybox]');
    if (!bar || !box || !('IntersectionObserver' in window)) return;
    var passed = false;
    function apply() {
      var show = passed && !cart.isOpen();
      bar.classList.toggle('is-shown', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      doc.body.classList.toggle('dld-sticky-visible', show);
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { passed = !en.isIntersecting && en.boundingClientRect.bottom < 0; });
      apply();
    }, { threshold: 0 }).observe(box);
    doc.addEventListener('dialed:cart:open', apply);
    doc.addEventListener('dialed:cart:close', apply);
  }

  /* -------------------------------------------------------------- forms */
  function initForms() {
    $$('form[data-dld-validate]').forEach(function (form) {
      form.setAttribute('novalidate', '');
      form.addEventListener('submit', function (e) {
        var email = $('input[type="email"]', form);
        var err = $('[data-dld-error]', form);
        if (email && !D.validEmail(email.value)) {
          e.preventDefault();
          email.setAttribute('aria-invalid', 'true');
          if (err) { err.textContent = err.getAttribute('data-message') || 'Enter a valid email address.'; err.hidden = false; }
          email.focus();
        } else if (email) {
          email.removeAttribute('aria-invalid');
          if (err) err.hidden = true;
        }
      });
      var input = $('input[type="email"]', form);
      if (input) input.addEventListener('input', function () {
        var err = $('[data-dld-error]', form);
        if (err) err.hidden = true;
        input.removeAttribute('aria-invalid');
      });
    });
  }

  /* ------------------------------------------------------------ filters */
  function initFilters() {
    $$('[data-dld-filters]').forEach(function (wrap) {
      var buttons = $$('[data-dld-filter]', wrap);
      var items = $$('[data-dld-cat]', $(wrap.getAttribute('data-dld-filters')) || doc);
      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          var cat = b.getAttribute('data-dld-filter');
          buttons.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          items.forEach(function (it) { it.hidden = !(cat === 'all' || it.getAttribute('data-dld-cat') === cat); });
        });
      });
    });
  }


  /* ------------------------------------------------------------ anchors */
  /* Horizon scrolls .page-wrapper (not the window) on desktop, so plain
     fragment navigation does not reach in-page anchors. */
  function scrollToHash(hash, smooth) {
    if (!hash || hash.length < 2) return false;
    var el;
    try { el = doc.getElementById(decodeURIComponent(hash.slice(1))); } catch (e) { el = null; }
    if (!el) return false;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({ block: 'start', behavior: smooth && !reduced ? 'smooth' : 'auto' });
    return true;
  }
  function initAnchors() {
    doc.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="#"]');
      if (!a || a.target === '_blank' || e.defaultPrevented) return;
      var url;
      try { url = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
      if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
      if (scrollToHash(url.hash, true)) {
        e.preventDefault();
        if (history.pushState) history.pushState(null, '', url.hash);
        cart.close();
        if (D.closeMenu) D.closeMenu();
        if (D.closeShop) D.closeShop();
      }
    });
    window.addEventListener('hashchange', function () { scrollToHash(location.hash, true); });
    if (location.hash) window.setTimeout(function () { scrollToHash(location.hash, false); }, 60);
  }

  /* -------------------------------------------------------------- video */
  function initVideo() {
    $$('[data-dld-video-facade]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.dld-video');
        var src = btn.getAttribute('data-dld-video-facade');
        var title = btn.getAttribute('data-title') || 'Video';
        if (!wrap || !src) return;
        var el;
        if (/\.(mp4|webm|mov)(\?|$)/i.test(src)) {
          el = doc.createElement('video');
          el.src = src; el.controls = true; el.autoplay = true; el.playsInline = true;
        } else {
          el = doc.createElement('iframe');
          el.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
          el.title = title; el.allow = 'autoplay; fullscreen; picture-in-picture'; el.allowFullscreen = true;
        }
        btn.replaceWith(el);
        var poster = wrap.querySelector('.dld-video__poster');
        if (poster) poster.remove();
        if (el.focus) el.focus();
      });
    });
  }



  /* --------------------------------------------------------- hero video */
  /* One source at a time (desktop ≥ breakpoint, mobile below), poster first,
     play only while the hero is on screen, never with reduced motion. */
  function initHeroVideo() {
    $$('[data-dld-hero-video]').forEach(function (video) {
      if (video.dataset.bound) return;
      video.dataset.bound = '1';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { video.removeAttribute('autoplay'); return; }
      var bp = Number(video.getAttribute('data-breakpoint')) || 760;
      var mq = window.matchMedia('(min-width: ' + bp + 'px)');
      var wanted = null;
      function apply() {
        var desktop = mq.matches;
        var src = video.getAttribute(desktop ? 'data-src-desktop' : 'data-src-mobile');
        var poster = video.getAttribute(desktop ? 'data-poster-desktop' : 'data-poster-mobile');
        if (poster) video.poster = poster;
        if (!src || src === wanted) return;
        wanted = src;
        var wasPlaying = !video.paused;
        video.classList.remove('is-playing');
        video.src = src;
        video.load();
        if (wasPlaying || inView) tryPlay();
      }
      var inView = false;
      function tryPlay() {
        if (!video.src) apply();
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
      video.addEventListener('playing', function () { video.classList.add('is-playing'); });
      video.addEventListener('error', function () { video.classList.remove('is-playing'); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            inView = en.isIntersecting;
            if (inView) { apply(); tryPlay(); } else { video.pause(); }
          });
        }, { threshold: 0.15 }).observe(video);
      } else { inView = true; apply(); tryPlay(); }
      var onChange = function () { apply(); };
      if (mq.addEventListener) mq.addEventListener('change', onChange); else mq.addListener(onChange);
      doc.addEventListener('visibilitychange', function () { if (doc.hidden) video.pause(); else if (inView) tryPlay(); });
    });
  }

  /* --------------------------------------------------------- focus trap */
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var dialog = [cart.el && !cart.el.hidden ? cart.el : null, (function () { var m = $('[data-dld-menu]'); return m && !m.hidden ? m : null; })()].filter(Boolean)[0];
    if (!dialog) return;
    var focusable = $$('a[href], button:not([disabled]):not([tabindex="-1"]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])', dialog)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && (doc.activeElement === first || !dialog.contains(doc.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (doc.activeElement === last || !dialog.contains(doc.activeElement))) { e.preventDefault(); first.focus(); }
  });

  /* ------------------------------------------------------------- escape */
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    cart.close();
    if (D.closeMenu) D.closeMenu();
    if (D.closeShop) D.closeShop();
  });

  function init() {
    cart.init();
    initHeader();
    initGalleries();
    initSticky();
    initForms();
    initFilters();
    initAnchors();
    initVideo();
    initHeroVideo();
    if (window.Shopify && Shopify.designMode) {
      doc.addEventListener('shopify:section:load', function () { initGalleries(); initForms(); initFilters(); initVideo(); initHeroVideo(); });
    }
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();
